(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    let loopedElement = true;
    if(document.querySelectorAll('#announcement-bar .swiper-slide').length === 1){
        loopedElement = false;
    }
    
    new Swiper(".bar-width-automate", {
        loop: loopedElement,
        speed: 600,
        watchOverflow: true,
        allowTouchMove: false,
        followFinger: false,
        simulateTouch: false,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                if (this.slides.length <= 1) {
                    this.allowSlidePrev = this.allowSlideNext = false; 
                    this.el.querySelector(".swiper-button-prev").setAttribute('hidden', ''); 
                    this.el.querySelector(".swiper-button-next").setAttribute('hidden', '');


                }
            }
        },
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-store-locator"]) return;
  try {
    


document.addEventListener('DOMContentLoaded', boxResize);
window.addEventListener('resize', boxResize);

function boxResize() {
  let divA = document.querySelector(".product-media-collage").offsetHeight,
      divB = document.querySelector(".product-media-thumbs");
  divB.style.maxHeight = divA + "px";
}


var scrolled=0;

document.querySelector('.pdp-thumbs-control-up').addEventListener('click', function(){
    scrolled=scrolled+100;
    document.querySelector('.product-media-thumbs').scrollBy(0, -100);
});

document.querySelector('.pdp-thumbs-control-down').addEventListener('click', function(){
    scrolled=scrolled-100;
    document.querySelector('.product-media-thumbs').scrollBy(0, 100);
});



document.querySelectorAll('.review--faqs__tabs button').forEach(btn => {
    btn.addEventListener('click', (e) => {
        let dataAttr = e.target.getAttribute('data-visibility');
        document.querySelectorAll('.review--faqs__tabs button').forEach( btn => {
            btn.classList.remove('active');
        })
        e.target.classList.add('active')
        document.querySelectorAll('.reviews-faq-tabs').forEach( tab => {
            tab.classList.remove('active');
        })
        document.querySelector(`.reviews-faq-tabs[data-visibility=${dataAttr}]`)?.classList.add('active')
    })
})





if (window.matchMedia('(max-width: 768px)').matches) {

    ScrollTrigger.create({
        
        trigger: ".pdp-ScrollTrigger-trigger",
        endTrigger:".pdp-ScrollTrigger-trigger",
        start: 'top bottom-=65px',
        end:"bottom top",
        toggleClass: {targets: ".pdp-info .product-form-button-list", className: "static"}

    });

}
else{



}

window.addEventListener('DOMContentLoaded', () => {
    const pdpRegimenSlider = new Swiper(".product-regimens .swiper", {
            slidesPerView: 1.2,
            spaceBetween: 5,
            watchSlidesProgress: true,
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                1011: {
                    freeMode: true,
                    slidesPerView: 4,
                    spaceBetween: 10,
                    centeredSlides: false,
                    scrollbar: false
                }
            },
        }
    );
})

window.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.pdp-back-to-top button').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    })

    window.addEventListener('scroll', () => {
        if (window.scrollY > 1000) {
            document.querySelector('.pdp-back-to-top').classList.add('active')
        } else {
            document.querySelector('.pdp-back-to-top').classList.remove('active')
        }
    })
})
            



  } catch(e) { console.error(e); }
})();
})();
